<template>
  <div>
    <!-- 热搜榜单 -->
    <div class="bannerImg"></div>
    <el-row>

      <ul class="listContainer">
        <li v-for="(item) in hotSearchList" :key="item.hotId">
          <el-col :span="21">
            {{ item.hotTitle }}
          </el-col>

          <el-col :span="2" :offset="1">
            <el-link :underline="false" class="hotWriteBtn" @click="getHotSearchArticle(item.hotId, item.hotTitle)">
            </el-link>
          </el-col>
        </li>
      </ul>

    </el-row>

  </div>
</template>

<script>

export default {
  name: 'index',
  data: function () {
    return {

      hostPoints: [],

      quickNews: [],
      hotSearchGroup: 0,
      quikPage: 1,
      quikLoading: true,

      hotTimer: null,
      hotSearchList: []
    }
  },

  methods: {
    getHotSearchArticle (id, title) {
      this.axios.postWithLoading('/webApi/v3/robot/writingByNetHotIds', { 'newsIds': id, 'hotTitle': title }).then((response) => {
        this.$router.push({ path: '/newsEdit', query: { articleId: response.data.autoNewsId, from: 'hot' } })
      })
    }

  },
  components: {

  },
  watch: {

  },
  mounted () {
    let _this = this
    this.axios.get('/webApi/v3/hot/allHotSearchWord', { '$noLoading': true }).then((response) => {
      _this.hotSearchList = response.data
    })
  }
}
</script>
<style lang="less" scoped>
.writeDialog {
  .bannerImg {
    background-image: url('../../assets/imgs/hotBanner.png');
  }

  .listContainer {
    height: 230px;
    overflow-y: scroll;
    padding: 0px 10px;
    padding-right: 20px;

    li {
      display: block;
      text-align: left;
      padding: 20px 0px;

      div {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .listContainer::-webkit-scrollbar {
    width: 5px;
    height: 100px;
    background-color: white;

  }

  .listContainer::-webkit-scrollbar-thumb {
    width: 5px;
    height: 30px;
    background-color: #E3EAFF;
    border-radius: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/write/hot.vue